export * from './agris-coriz-perder-dialog.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/agris-cotizacion-detalle-page/agris-coriz-perder-dialog/index.ts